webpackJsonp([24],{

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyBankBatchForm_vue__ = __webpack_require__(2606);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15210e04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyBankBatchForm_vue__ = __webpack_require__(3727);
function injectStyle (ssrContext) {
  __webpack_require__(3713)
  __webpack_require__(3715)
  this["$style"] = __webpack_require__(3717)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15210e04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyBankBatchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15210e04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyBankBatchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(101);
var toIObject = __webpack_require__(100);
var isEnum = __webpack_require__(235).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1446), __esModule: true };

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1447);
module.exports = __webpack_require__(12).Object.values;


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(28);
var $values = __webpack_require__(1441)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
  return new Worker(__webpack_require__.p + "2f6ec96fc704f66aecaa.worker.js");
};

/***/ }),

/***/ 2606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CompanyBankBatchExcel_vue__ = __webpack_require__(3719);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { CompanyBankBatchExcel: __WEBPACK_IMPORTED_MODULE_4__components_CompanyBankBatchExcel_vue__["a" /* default */] },
  data: function data() {
    return {
      form: {
        data: []
      },
      error_data: [],
      percentage: 0,
      file: null,
      fileHeader: [{
        key: 'id',
        text: 'ID'
      }, {
        key: 'company_name',
        text: '账户名称'
      }, {
        key: 'remark',
        text: '备注'
      }, {
        key: 'bank_account',
        text: '银行账号'
      }, {
        key: 'bank',
        text: '开户银行支行'
      }, {
        key: 'bank_headquarters',
        text: '开户银行总行'
      }]
    };
  },

  computed: {},
  watch: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map([]), {
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$refs.companyExcel.$refs.companyBatchExcel.clearFiles();
    },
    getCompanyBatchDemo: function getCompanyBatchDemo() {
      var demo = [{
        'id': '0',
        'company_name': '示例公司名称',
        'remark': '公司备注信息',
        'bank_account': '642158791335413',
        'bank': '中国工商银行上海分行',
        'bank_headquarters': '中国工商银行上海总行'
      }, {
        'id': '*id为0时新增数据，否则为修改数据',
        'company_name': '*银行账户名称',
        'remark': '备注，可留空',
        'bank_account': '*注意使用文本格式',
        'bank': '*上传时请删除本说明行',
        'bank_headquarters': '*上传时请删除本说明行'
      }];
      this.$export('批量上传对公账户信息', demo, { fileHeader: this.fileHeader });
    },
    getFormData: function getFormData() {
      return filter.copyJson(this.form.data);
    },
    onSubmit: function onSubmit() {
      if (this.form.data.length === 0) {
        this.$message.error('请选择文件');
      } else {
        this.create();
      }
    },
    excelFileRemove: function excelFileRemove(fileList) {
      if (fileList.length === 0) {
        this.form.data = [];
      }
    },
    create: function create() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, index, param, num, info, key, apiUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _this.getFormData();

                _this.error_data = [];
                index = 0;

              case 3:
                if (!(index < data.length)) {
                  _context.next = 22;
                  break;
                }

                param = data[index];
                num = index + 1;

                _this.percentage = num / data.length * 100;

                info = '第' + num + '行 ';

                if (!_this.checkParams(param, info)) {
                  _context.next = 19;
                  break;
                }

                for (key in param) {
                  param[key] = param[key] + '';
                }
                _context.prev = 10;
                apiUrl = param.id > 0 ? 'updateCompanyBankAccount' : 'createCompanyBankAccount';
                _context.next = 14;
                return request.loading(apiUrl, param);

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](10);

                _this.error_data.push(info + _context.t0.message);

              case 19:
                index++;
                _context.next = 3;
                break;

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[10, 16]]);
      }))();
    },
    checkParams: function checkParams(param, info) {
      var err = '';
      var rule = {
        company_name: '账户名称',
        bank_account: '银行账号',
        bank: '开户银行支行',
        bank_headquarters: '开户银行总行'
      };

      for (var ruleKey in rule) {
        if (!param[ruleKey]) {
          err = rule[ruleKey] + ' 为空';
          break;
        }
      }

      if (err) {
        this.error_data.push(info + err);
        return false;
      }
      return true;
    }
  })
});

/***/ }),

/***/ 2607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var worker = new __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default.a();
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getDemo: function getDemo() {
      this.$emit('getCompanyBatchDemo');
    },
    excelFileChange: function excelFileChange(file, fileList) {
      if (file.status === 'ready') {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length >= 2) {
          fileList.shift();
        }
      }
    },
    excelFileRemove: function excelFileRemove(file, fileList) {
      this.$emit('excelFileRemove', fileList);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploadRequest: function uploadRequest(obj) {
      var _this = this;

      this.loading = true;
      this.$emit('change-file', obj.file);
      worker.postMessage({ file: obj.file, options: { header: 1 } });
      worker.onmessage = function (event) {
        // 处理数据
        _this.handleExcelData(event.data);
        _this.loading = false;
      };
    },
    handleExcelData: function handleExcelData(rows) {
      var _this2 = this;

      var items = [];
      var tableHeader = {
        id: {
          index: null,
          text: 'ID'
        },
        company_name: {
          index: null,
          text: '账户名称'
        },
        remark: {
          index: null,
          text: '备注'
        },
        bank_account: {
          index: null,
          text: '银行账号'
        },
        bank: {
          index: null,
          text: '开户银行支行'
        },
        bank_headquarters: {
          index: null,
          text: '开户银行总行'
        }
      };
      try {
        rows.forEach(function (row, rowIndex) {
          var item = {};
          row.forEach(function (cell, cellIndex) {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var header = _step.value;

                    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(header.index)) {
                      _this2.loading = false;
                      _this2.$refs.companyBatchExcel.clearFiles();
                      throw new Error('\u627E\u4E0D\u5230 [' + header.text + '] \u8868\u5934');
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
              // 表格的行数据获取
              for (var field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell;
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _header = _step2.value;

                  if (cell === _header.text) {
                    _header.index = cellIndex;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          });
          rowIndex && items.push(item);
        });
        this.$emit('change', items);
      } catch (e) {
        this.$alert(e.toString(), '提示', { type: 'error' });
        throw new Error(e);
      }
    }
  }
});

/***/ }),

/***/ 3067:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UserBankBatchExcel_vue__ = __webpack_require__(5708);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { UserBankBatchExcel: __WEBPACK_IMPORTED_MODULE_4__components_UserBankBatchExcel_vue__["a" /* default */] },
  data: function data() {
    return {
      form: {
        data: []
      },
      error_data: [],
      percentage: 0,
      file: null,
      fileHeader: [{
        key: 'user_name',
        text: '用户名'
      }, {
        key: 'department_name',
        text: '部门'
      }, {
        key: 'first_approver_name',
        text: '一级审批人'
      }, {
        key: 'second_approver_name',
        text: '二级审批人'
      }, {
        key: 'third_approver_name',
        text: '三级审批人'
      }, {
        key: 'fourth_approver_name',
        text: '四级审批人'
      }, {
        key: 'name',
        text: '账户名称'
      }, {
        key: 'bank_account',
        text: '银行账号'
      }, {
        key: 'bank',
        text: '开户银行支行'
      }, {
        key: 'bank_headquarters',
        text: '开户银行总行'
      }]
    };
  },

  computed: {},
  watch: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map([]), {
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$refs.userBankExcel.$refs.userBankBatchExcel.clearFiles();
    },
    getUserBatchDemo: function getUserBatchDemo() {
      var demo = [{
        'user_name': 'Ivys Chen',
        'department_name': '产品技术部',
        'first_approver_name': 'Yue Zhang',
        'second_approver_name': 'Irene Huang',
        'third_approver_name': 'Fenix',
        'fourth_approver_name': 'Sam Huang',
        'name': '张三',
        'bank_account': '60000000000000001',
        'bank': '工商银行上海金陵支行',
        'bank_headquarters': '中国工商银行总行'
      }, {
        'user_name': '*管理端账户名称',
        'department_name': '*建议以企微通讯录架构部门名称命名',
        'first_approver_name': '*管理端账户名称',
        'second_approver_name': '*管理端账户名称',
        'third_approver_name': '*管理端账户名称',
        'fourth_approver_name': '*管理端账户名称',
        'name': '*银行户名',
        'bank_account': '*注意使用文本格式',
        'bank': '*上传时请删除本说明行',
        'bank_headquarters': '*上传时请删除本说明行'
      }];
      this.$export('批量上传员工账户信息', demo, { fileHeader: this.fileHeader });
    },
    getFormData: function getFormData() {
      return filter.copyJson(this.form.data);
    },
    onSubmit: function onSubmit() {
      if (this.form.data.length === 0) {
        this.$message.error('请选择文件');
      } else {
        this.create();
      }
    },
    excelFileRemove: function excelFileRemove(fileList) {
      if (fileList.length === 0) {
        this.form.data = [];
      }
    },
    create: function create() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, index, param, num, info, api;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _this.getFormData();

                _this.error_data = [];
                index = 0;

              case 3:
                if (!(index < data.length)) {
                  _context.next = 22;
                  break;
                }

                param = data[index];
                num = index + 1;

                _this.percentage = num / data.length * 100;

                info = '第' + num + '行 ';

                if (!_this.checkParams(param, info)) {
                  _context.next = 19;
                  break;
                }

                _context.prev = 9;
                api = 'batchCreateUserBankAccount';

                if (_this.$route.meta.type === 'edit') {
                  api = 'batchEditUserBankAccount';
                }
                _context.next = 14;
                return request.loading(api, param);

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](9);

                _this.error_data.push(info + _context.t0.message);

              case 19:
                index++;
                _context.next = 3;
                break;

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 16]]);
      }))();
    },
    checkParams: function checkParams(param, info) {
      var err = '';
      var rule = {
        user_name: '用户名',
        department_name: '部门',
        first_approver_name: '一级审批人',
        second_approver_name: '二级审批人',
        third_approver_name: '三级审批人',
        fourth_approver_name: '四级审批人',
        name: '账户名称',
        bank_account: '银行账号',
        bank: '开户行'
      };

      for (var ruleKey in rule) {
        if (!param[ruleKey]) {
          err = rule[ruleKey] + ' 为空';
          break;
        }
      }

      if (err) {
        this.error_data.push(info + err);
        return false;
      }
      return true;
    }
  })
});

/***/ }),

/***/ 3068:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var worker = new __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default.a();
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getDemo: function getDemo() {
      this.$emit('getUserBatchDemo');
    },
    excelFileChange: function excelFileChange(file, fileList) {
      if (file.status === 'ready') {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length >= 2) {
          fileList.shift();
        }
      }
    },
    excelFileRemove: function excelFileRemove(file, fileList) {
      this.$emit('excelFileRemove', fileList);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploadRequest: function uploadRequest(obj) {
      var _this = this;

      this.loading = true;
      this.$emit('change-file', obj.file);
      worker.postMessage({ file: obj.file, options: { header: 1 } });
      worker.onmessage = function (event) {
        // 处理数据
        _this.handleExcelData(event.data);
        _this.loading = false;
      };
    },
    handleExcelData: function handleExcelData(rows) {
      var _this2 = this;

      var items = [];
      var tableHeader = {
        user_name: {
          index: null,
          text: '用户名'
        },
        department_name: {
          index: null,
          text: '部门'
        },
        department_job_name: {
          index: null,
          text: '岗位'
        },
        realname: {
          index: null,
          text: '员工姓名'
        },
        first_approver_name: {
          index: null,
          text: '一级审批人'
        },
        second_approver_name: {
          index: null,
          text: '二级审批人'
        },
        third_approver_name: {
          index: null,
          text: '三级审批人'
        },
        fourth_approver_name: {
          index: null,
          text: '四级审批人'
        },
        name: {
          index: null,
          text: '账户名称'
        },
        bank_account: {
          index: null,
          text: '银行账号'
        },
        bank: {
          index: null,
          text: '开户银行支行'
        },
        bank_headquarters: {
          index: null,
          text: '开户银行总行'
        }
        // 批量编辑时务必提供ID字段
      };if (this.$route.meta.type === 'edit') {
        tableHeader.id = { index: null, text: 'ID' };
      }
      try {
        rows.forEach(function (row, rowIndex) {
          var item = {};
          row.forEach(function (cell, cellIndex) {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var header = _step.value;

                    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(header.index)) {
                      _this2.loading = false;
                      _this2.$refs.userBankBatchExcel.clearFiles();
                      throw new Error('\u627E\u4E0D\u5230 [' + header.text + '] \u8868\u5934');
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
              // 表格的行数据获取
              for (var field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell;
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _header = _step2.value;

                  if (cell === _header.text) {
                    _header.index = cellIndex;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          });
          rowIndex && items.push(item);
        });
        this.$emit('change', items);
      } catch (e) {
        this.$alert(e.toString(), '提示', { type: 'error' });
        throw new Error(e);
      }
    }
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBankBatchForm_vue__ = __webpack_require__(3067);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156526e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBankBatchForm_vue__ = __webpack_require__(5716);
function injectStyle (ssrContext) {
  __webpack_require__(5702)
  __webpack_require__(5704)
  this["$style"] = __webpack_require__(5706)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-156526e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBankBatchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156526e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBankBatchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7bb44894", content, true, {});

/***/ }),

/***/ 3714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CompanyBankBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3715:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3716);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("13155cac", content, true, {});

/***/ }),

/***/ 3716:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CompanyBankBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3717:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3718);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7878325e", content, true, {});

/***/ }),

/***/ 3718:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CompanyBankBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyBankBatchExcel_vue__ = __webpack_require__(2607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b738e42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyBankBatchExcel_vue__ = __webpack_require__(3726);
function injectStyle (ssrContext) {
  __webpack_require__(3720)
  __webpack_require__(3722)
  this["$style"] = __webpack_require__(3724)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b738e42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyBankBatchExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b738e42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyBankBatchExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3720:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3721);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("01ba7058", content, true, {});

/***/ }),

/***/ 3721:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CompanyBankBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3722:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3723);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("111b7b8c", content, true, {});

/***/ }),

/***/ 3723:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-3b738e42]{margin-right:10px;margin-bottom:10px}.re-el-upload-width-max[data-v-3b738e42] .el-upload-dragger{height:200px}", "", {"version":3,"sources":["/workspace/src/views/company-bank-account/components/CompanyBankBatchExcel.vue"],"names":[],"mappings":"AACA,mBAAmB,kBAAkB,kBAAkB,CACtD,AACD,4DAA4D,YAAY,CACvE","file":"CompanyBankBatchExcel.vue","sourcesContent":["\na[data-v-3b738e42]{margin-right:10px;margin-bottom:10px\n}\n.re-el-upload-width-max[data-v-3b738e42] .el-upload-dragger{height:200px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3724:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3725);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c5c86164", content, true, {});

/***/ }),

/***/ 3725:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CompanyBankBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"companyBatchExcel",staticClass:"re-el-upload-width-max",attrs:{"drag":"","action":"","accept":".xlsx","on-remove":_vm.excelFileRemove,"on-change":_vm.excelFileChange,"before-upload":_vm.beforeFileUpload,"http-request":_vm.uploadRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击选择文件")]),_vm._v(" "),_c('br'),_vm._v("\n    只能选择Microsoft Office Excel文件，且不超过2MB")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n    Excel需要包含表头[ID, 账户名称, 银行账号, 开户银行支行, 开户银行总行, 备注] "),_c('br'),_vm._v("\n    银行账号不得重复 "),_c('br'),_vm._v("\n    任意字段值不得为空 "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.getDemo}},[_vm._v("下载Demo")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3727:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("财务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"选择Excel"}},[_c('company-bank-batch-excel',{ref:"companyExcel",on:{"getCompanyBatchDemo":_vm.getCompanyBatchDemo,"excelFileRemove":_vm.excelFileRemove,"change-file":function (_) { return this$1.file = _; },"change":function (_) { return this$1.form.data = _; }}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传进度"}},[_c('div',{staticStyle:{"margin-top":"8px"}},[(_vm.percentage < 100)?_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":18,"color":"#666666"}}):_vm._e(),_vm._v(" "),(_vm.percentage === 100)?_c('el-progress',{attrs:{"percentage":100,"stroke-width":18,"status":"success"}}):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"错误记录"}},[_vm._l((_vm.error_data),function(item){return _c('div',[_c('span',[_vm._v(_vm._s(item))])])})],2)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("开始上传\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5702:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5703);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("76df6092", content, true, {});

/***/ }),

/***/ 5703:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserBankBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5704:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5705);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("14f6efec", content, true, {});

/***/ }),

/***/ 5705:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserBankBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5706:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5707);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("20596b88", content, true, {});

/***/ }),

/***/ 5707:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserBankBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBankBatchExcel_vue__ = __webpack_require__(3068);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7187d8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBankBatchExcel_vue__ = __webpack_require__(5715);
function injectStyle (ssrContext) {
  __webpack_require__(5709)
  __webpack_require__(5711)
  this["$style"] = __webpack_require__(5713)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7187d8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBankBatchExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7187d8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBankBatchExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5709:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5710);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3b4a8a36", content, true, {});

/***/ }),

/***/ 5710:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserBankBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5711:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5712);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("18f527ba", content, true, {});

/***/ }),

/***/ 5712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-b7187d8a]{margin-right:10px;margin-bottom:10px}.re-el-upload-width-max[data-v-b7187d8a] .el-upload-dragger{height:200px}", "", {"version":3,"sources":["/workspace/src/views/user-bank-account/components/UserBankBatchExcel.vue"],"names":[],"mappings":"AACA,mBAAmB,kBAAkB,kBAAkB,CACtD,AACD,4DAA4D,YAAY,CACvE","file":"UserBankBatchExcel.vue","sourcesContent":["\na[data-v-b7187d8a]{margin-right:10px;margin-bottom:10px\n}\n.re-el-upload-width-max[data-v-b7187d8a] .el-upload-dragger{height:200px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("72b25e80", content, true, {});

/***/ }),

/***/ 5714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserBankBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userBankBatchExcel",staticClass:"re-el-upload-width-max",attrs:{"drag":"","action":"","accept":".xlsx","on-remove":_vm.excelFileRemove,"on-change":_vm.excelFileChange,"before-upload":_vm.beforeFileUpload,"http-request":_vm.uploadRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击选择文件")]),_vm._v(" "),_c('br'),_vm._v("\n    只能选择Microsoft Office Excel文件，且不超过2MB")]),_vm._v(" "),(_vm.$route.meta.type === 'create')?_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n    Excel需要包含表头[用户名, 部门, 岗位, 员工姓名, 一级审批人, 二级审批人, 三级审批人, 四级审批人, 账户名称, 银行账号, 开户银行支行, 开户银行总行] "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("银行账号不得重复")]),_vm._v(" "),_c('br'),_vm._v("\n    任意字段值均不得为空 "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.getDemo}},[_vm._v("下载上传文件Demo")])]):_vm._e(),_vm._v(" "),(_vm.$route.meta.type === 'edit')?_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n    Excel需要包含表头[ID, 用户名, 部门, 岗位, 员工姓名, 一级审批人, 二级审批人, 三级审批人, 四级审批人] "),_c('br'),_vm._v("\n    请使用列表页的导出功能，在导出后的文件上进行编辑 "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("不支持修改以下字段 [账户名称, 银行账号, 开户银行支行, 开户银行总行]")]),_vm._v(" "),_c('br'),_vm._v("\n    如数据录入错误，请在列表页中删除后重新添加 "),_c('br')]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("财务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"选择Excel"}},[_c('user-bank-batch-excel',{ref:"userBankExcel",on:{"getUserBatchDemo":_vm.getUserBatchDemo,"excelFileRemove":_vm.excelFileRemove,"change-file":function (_) { return this$1.file = _; },"change":function (_) { return this$1.form.data = _; }}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传进度"}},[_c('div',{staticStyle:{"margin-top":"8px"}},[(_vm.percentage < 100)?_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":18,"color":"#666666"}}):_vm._e(),_vm._v(" "),(_vm.percentage === 100)?_c('el-progress',{attrs:{"percentage":100,"stroke-width":18,"status":"success"}}):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"错误记录"}},[_vm._l((_vm.error_data),function(item){return _c('div',[_c('span',[_vm._v(_vm._s(item))])])})],2)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("开始上传\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user-bank-account-batch.fd359d4dfee19f69e1cb.js